import Cookies from 'universal-cookie';

const mobileAppCookieKey = 'embView';
const mobileAppCookieValue = 'atMobileApp';

const cookies = new Cookies();

export const isWebExperience = cookies.get(mobileAppCookieKey) !== mobileAppCookieValue;

export const handleNativeAppExternalNavigationLink = (url: string, e?: MouseEvent) => {
    e?.preventDefault();
    globalThis?.autotraderMobileApp?.navigate.launchUrl(url, { mode: 'externalApplication' });
};
